export default "__VITE_ASSET__069b0136__"